<template>
    <div v-if="item" class="border border-[#E2E2E2] rounded-[0.5rem] p-2 py-3">
        <!-- Content Section -->
        <div class="flex flex-col gap-2 md:gap-3 md:flex-row">
            <!-- Image Section -->
            <NuxtLink :to="singleNewsLink" class="md:w-1/4 ">
                <img :src="item.image" @error="onImageError" :alt="item.title"
                    class="rounded-[0.625rem] w-full h-auto max-h-[15.12rem] md:w-[8.125rem] md:h-[8.875rem] object-cover " />
            </NuxtLink>

            <!-- Text Content Section -->
            <div class="md:w-3/4 mt-4 md:mt-0 md:ml-4 flex flex-col">
                <div>
                    <div class="flex justify-between items-center mb-2">
                        <NuxtLink :to="singleNewsLink" >
                            <h3 class="text-[0.8rem] md:text-[1.1rem] 3xl:text-[1.12rem] font-normal text-gray-800 capitalize">
                                {{ item.title }}
                            </h3>
                        </NuxtLink>
                    </div>
                    <p class="text-gray-600 mb-4 ellipsis-x2">
                        <TruncateText :text="item.description" :limit="descriptionCharactersLimit"
                            class="text-[13.7px] md:text-[14.7px] 3xl:text-[1rem] font-normal"
                            appendedClass="text-[#a6a4a4] leading-[1.6] multi-lines-text">
                            <template #toggle-button="{ isExpanded, toggle }">
                                <button class="text-primary !outline-none hover:brightness-110 duration-150 ease-linear"
                                    @click="toggle">
                                    {{ isExpanded ? $t('general.show_less') : $t('general.read_more') }}
                                </button>
                            </template>
                        </TruncateText>
                    </p> 
                </div>
                <div class="flex justify-between mt-auto sm:justify-start gap-[2rem] text-gray-500  text-[13.7px] md:text-[14.7px] 3xl:text-[1rem]">
                    <span  class="flex flex-wrap gap-1.5">
                        <img :src="viewsIcon" class="w-[0.75rem] h-auto object-contain" alt with="12" height="12" />
                        <span >{{ item.views }} {{ $t('user.store.views') }}</span>
                    </span>
                    <span class="flex flex-wrap gap-1.5">
                        <img :src="dateIcon" class="w-[0.75rem] h-auto object-contain" alt with="12" height="12" />
                        <span>{{ formatedDate }}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TruncateText from "@/components/generic/TruncateText.vue";
import viewsIcon from "@/assets/icons/view_eye.svg";
import dateIcon from "@/assets/icons/date.svg";
import moment from "moment-timezone";
import { onImageError, ROUTESNAMES } from "@/helpers";

export default {
    data(){
        return {
            descriptionCharactersLimit: 200,
            ROUTESNAMES,
            viewsIcon,
            dateIcon
        }
    },
    props: {
        item: {
            type: Object,
            required: true,
            default: () => ({})
        },
    },
    components: {
        TruncateText
    },
    computed: {
        singleNewsLink(){
            return `${ROUTESNAMES?.user.news}/${this.item?.id}`;
        },
        formatedDate(){
            return moment(this.item?.creation_date).locale('en').format('DD/MM/YYYY');
        }
    },
    methods: {
        onImageError
    }
}
</script>

<style></style>